// スクロール操作の抽象化。
// iOS Chrome（CriOS）はドキュメントスクロールがツールバーの収納・展開と連動する際に
// WebViewのコンテンツオフセットがずれて固着し、上端まで戻れなくなる不具合がある
// （外部リンクから新規タブで開いたときに発生しやすい）。
// そのためCriOSではbodyを独立スクロールコンテナにして回避する（index.htmlで
// htmlに .crios クラスを付与し、global.cssでスクロール構造を切り替える）。
// それ以外のブラウザは標準どおりドキュメント（window）スクロール。

export const isBodyScrollMode = (): boolean =>
  document.documentElement.classList.contains('crios');

export const getScrollY = (): number =>
  isBodyScrollMode() ? document.body.scrollTop : window.scrollY;

export const scrollToY = (top: number, behavior: ScrollBehavior = 'instant'): void => {
  if (isBodyScrollMode()) {
    document.body.scrollTo({ top, behavior });
  } else {
    window.scrollTo({ top, behavior });
  }
};

export const getMaxScrollY = (): number =>
  isBodyScrollMode()
    ? document.body.scrollHeight - document.body.clientHeight
    : document.documentElement.scrollHeight - window.innerHeight;
